const footerLinks = [
  {
    title: "核心能力",
    items: [
      { label: "多源播放", href: "#features" },
      { label: "线路切换", href: "#features" },
      { label: "自动选源", href: "#features" },
      { label: "备用线路", href: "#features" },
    ],
  },
  {
    title: "快速入口",
    items: [
      { label: "使用教程", href: "#how" },
      { label: "热门番剧", href: "#hot" },
      { label: "常见问题", href: "#faq" },
      { label: "关于我们", href: "#about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/80">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-tv-2-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">小猴看番</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              聚合多线路播放源，支持线路切换、备用线路秒切与多源播放自动选源，追番不等待。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="#top"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#top"
                aria-label="邮件"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-mail-line"></i>
              </a>
              <a
                href="#top"
                aria-label="微信"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-wechat-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-semibold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 小猴看番. 仅提供技术信息分享，请支持正版内容。
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="text-xs text-foreground-600 transition-colors hover:text-primary-600">
              帮助中心
            </a>
            <a href="#about" className="text-xs text-foreground-600 transition-colors hover:text-primary-600">
              联系我们
            </a>
            <a href="#top" className="text-xs text-foreground-600 transition-colors hover:text-primary-600">
              返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}